var Cube = require('cube-js')
string = require('sprintf-js');

var player = function player(conf) {
    this.container = conf.container;

    this.frame_box = this.container.find('.frame-box');
    this.frame = this.container.find('.frame');
    this.content = this.container.find('.content');
    this.init();
};

Cube.mix(player.prototype, {

    container: null,
    frame_box: null,
    player_list: {},
    is_phone: false,

    init: function() {
        var events = {
            'click li a': 'onClick',
            'mouseenter li a': 'onClick',
        };

        Cube.bindEvents(this, events, this.container);

        this.loadImage(1);
        this.adjustSize();
    },

    onResize: function() {
        this.adjustSize();
    },

    adjustSize: function() {

        var window_width = $(window).width();
        var ratio = window_width / 1920;

        var width_for_frame = 329;
        var height_for_frame = 683;

        var top_patten = 75;
        var left_patten = 18;

        var width_for_content = 293;
        var height_for_content = 530;

        if (window_width < 728) {
            ratio = window_width / 414;
            width_for_frame = 100;
            height_for_frame = 208;
            top_patten = 23;
            left_patten = 5;
            width_for_content = 91;
            height_for_content = 165;
        }

        var css_for_box = {
            width: ratio * width_for_frame,
            height: ratio * height_for_frame,
        };
        var css_for_inner_pic = {
            width: ratio * width_for_content,
            height: ratio * height_for_content,
            'margin-top': ratio * top_patten,
            'margin-left': ratio * left_patten,
        };
        this.frame_box.css(css_for_box);
        this.content.css(css_for_inner_pic);
    },


    onClick: function(e) {
        var index = $(e.target).parents('li').data('index');
        this.loadImage(index);
    },

    loadImage: function(index) {
        var that = this;
        var url = '';
        var window_width = $(window).width();
        if (window_width <= 768) {
          url = '/static/img/home/home-app-feature-list/' + index + '-1.jpg';
        } else {
          url = '/static/img/home/home-app-feature-list/' + index + '.jpg';
        }

        var image = new Image();
        image.onload = function() {
            that.content.attr('src', url);
        };
        image.src = url;

    }
});

module.exports = player;



//////////////////
// WEBPACK FOOTER
// ./src/js/home/frameplayer.js
// module id = 52
// module chunks = 3